import { ref } from "vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { create } from "@/composables/useNotifications";

type EnableAlertsOptions = {
    preserveScroll?: boolean;
    notifyOnSuccess?: boolean;
    notifyOnError?: boolean;
    successTitle?: string;
    successText?: string;
    errorTitle?: string;
    errorText?: string;
    onSuccess?: () => void;
    onError?: (errors: Record<string, unknown>) => void;
};

export default function useEnableAlerts() {
    const enableLoading = ref(false);

    const enableAlerts = (opts: EnableAlertsOptions = {}) => {
        if (enableLoading.value) return Promise.resolve();

        enableLoading.value = true;

        const {
            preserveScroll = true,
            notifyOnSuccess = true,
            notifyOnError = false,
            successTitle = "Alerts Enabled",
            successText = "Alerts have been successfully enabled and configured.",
            errorTitle = "Enable failed",
            errorText = "Failed to enable alerts.",
            onSuccess,
            onError,
        } = opts;

        return new Promise<void>((resolve, reject) => {
            router.post(
                route("alerts.enabled.store"),
                {},
                {
                    preserveScroll,
                    onSuccess: () => {
                        if (notifyOnSuccess) {
                            create({
                                title: successTitle,
                                text: successText,
                                type: "success",
                            });
                        }
                        onSuccess?.();
                        resolve();
                    },
                    onError: (errors) => {
                        if (notifyOnError) {
                            create({
                                title: errorTitle,
                                text: errorText,
                                type: "error",
                            });
                        }
                        onError?.(errors);
                        reject(errors);
                    },
                    onFinish: () => {
                        enableLoading.value = false;
                    },
                },
            );
        });
    };

    return { enableAlerts, enableLoading };
}
